import { actionTypes } from "../actions/loading.action";

const INITIAL_STATE = {
  open: false,
  msg: "Carregando...",
};

// eslint-disable-next-line
export default (state = INITIAL_STATE, { type, payLoad }) => {
  switch (type) {
    case actionTypes.CHAGE:
      return { ...state, ...payLoad };
    default:
      return state;
  }
};
